<div  *ngIf="!load"class="card mb-4">
  <div class="card-body">

      <div class="text-muted small">
        <span>Clientes que não enviam borderô a mais de <strong>60 dias</strong></span>
      </div>
  </div>

  <div class="px-2">
    <div class="w-100">
     <ol class="list-group list-group-numbered mb-3">
      <li class="list-group-item d-flex justify-content-between align-items-start" *ngFor="let clientes of cliente">
        <div class="ms-2 me-auto">
          <div class="user"><strong>Cliente: </strong>{{clientes.credor}}</div>
        </div>
      </li>
    </ol>
    </div>
  </div>

</div>

<div *ngIf="load" class="card mb-4" style="display: flex;flex-direction: column;justify-content: center;align-items: center">

  <div class="card-body">

  </div>

  <div class="card-body">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>

  <div class="card-body">
  </div>

</div>
